import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import ModalTemplate from '@components/modalTemplate';
import TextAreaComp from '@components/formField/TextAreaComp';

export default function DeclineModal({ isOpen, onClose, onSubmit, value, onChange, isInvalid }) {
    return (
        <ModalTemplate
            isOpen={isOpen}
            onClose={onClose}
            width="720px"
            borderRadius="12px"
            isClosebyOverlayClick={false}
        >
            <Box p="24px">
                <Flex mb="12px">
                    <Text fontWeight="600" fontSize={"md"}>
                        Promotion Claim Declined
                    </Text>
                    <Button onClick={onClose} variant="unstyled" ml="auto">
                        <CloseIcon />
                    </Button>
                </Flex>
                <Box my="52px">
                    <TextAreaComp
                        isSideLabel
                        label="Reason for Decline"
                        placeholder="Tuliskan alasan Consumer Promotion ini ditolak"
                        value={value}
                        onChange={onChange}
                        isInvalid={isInvalid}
                        helperText={isInvalid ? 'Reason for decline is required' : ''}
                        debounceDelay={0}
                    />
                </Box>
                <Flex gap="12px" justifyContent="end">
                    <Button onClick={onClose} variant="outline" px="52px">
                        Batal
                    </Button>
                    <Button onClick={onSubmit} px="52px">
                        Simpan
                    </Button>
                </Flex>
            </Box>
        </ModalTemplate>
    );
}
